<template>
  <div class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start" style="min-width: 500px;">
    <InputGroupLabel
      name="categoryTitle"
      caption="変更処理（解約・変更）"
      class="mt-4"
    />

    <!-- 種別 -->
    <div class="sm:col-span-full">
      <SelectionButton2
        name="employmentClass"
        :caption="items['classification']"
        v-model="rp.classification"
        :disabled="referenceMode2"
        :item="classList"
        :multiSelect="false"
        :required="true"
        :error="!requireValidateArr('classification').result"
        :errorMessage="requireValidateArr('classification').message"
        @change="changeClassification()"
      />
    </div>

    <!-- 変更日・解約日 -->
    <div v-if="className(rp.classification)" class="sm:col-span-full">
      <WmsDateInput
        name="changeDate"
        :caption="className(rp.classification)=='解約'?'解約日':items['changeDate']"
        v-model="rp.changeDate"
        :disabled="referenceMode2"
        :clearable="true"
        :required="isRequired('changeDate')"
        :error="!requireValidateStr('changeDate').result"
        :errorMessage="requireValidateStr('changeDate').message"
        @change="setTitle()"
      />
    </div>

    <!-- 得意先 -->
    <div v-if="className(rp.classification)" class="sm:col-span-full">
      <WmsSuggestInput
        name="clientName"
        :caption="items['clientName']"
        v-model="rp.clientName"
        :disabled="referenceMode2"
        :required="true"
        :displayField="['clientName', 'clientDepartmentName']"
        :selectionItems="clientLists"
        :error="!requireValidateStr('clientName').result"
        :errorMessage="requireValidateStr('clientName').message"
        @selected="clientSelected($event)"
        @change="clientChange()"
      >
      </WmsSuggestInput>
    </div>

    <!-- 得意先変更（得意先で1回。得意先を選ぶ欄のすぐ下） -->
    <div v-if="rp.clientCode && rp.classification=='1'" class="sm:col-span-full text-sm flex" :class="rp.changeClient?'font-bold text-gray-700':'text-gray-600 my-3'">
      <div class="self-center cursor-pointer whitespace-nowrap">
        <input type="checkbox" id="client" v-model="rp.changeClient" @change="changeCheckCode" :disabled="referenceMode">
        <label for="client" class="p-2" :class="rp.changeClient?'text-indigo-700':''">得意先 変更</label>
      </div>
      <!-- チェックしたときだけ変更後を出す -->
      <template v-if="rp.changeClient">
        <div class="self-center mx-2">⇒</div>
        <div class="w-full">
          <WmsSuggestInput
            v-if="!referenceMode"
            caption="変更後"
            id="client-name"
            name="clientName2"
            :selectionItems="clientLists"
            :displayField="['clientName', 'clientDepartmentName']"
            v-model="rp.clientName2"
            :required="true"
            :error="!rp.clientCode2"
            errorMessage="変更後の得意先をドロップダウンから選択してください。"
            class="min-w-300px w-full"
            @selected="clientSelected2"
            @change="clientNameChanged2"
          >
          </WmsSuggestInput>
          <div v-else class="text-xs">
            <div class="mb-2">変更後</div>
            <div>{{ rp.clientName2 }}</div>
          </div>
          <div class="text-xs mt-1">（得意先コード：{{ rp.clientCode2 }}）</div>
        </div>
      </template>
    </div>

    <!-- 得意先の情報 -->
    <div v-if="rp.clientCode" class="sm:col-span-full text-sm text-gray-700 border border-blue-700 rounded px-2 pt-1 pb-2">
      <div class="text-blue-600 text-xs font-bold flex">得意先情報
        <PrimaryButton v-if="!referenceMode2" text="再取得" size="xs" class="ml-auto" @click="getBillingData()"></PrimaryButton>
      </div>

      <div class="ml-3 font-bold text-xs text-gray-700 mt-1">{{ rp.clientName }} （得意先コード： {{ rp.clientCode }}）</div>

      <!-- 請求先情報 -->
      <div v-if="rp.cc" class="table border-collapse mt-2 text-xs">
        <div class="table-row">
          <div class="table-cell px-2 py-1 font-bold text-gray-500">予定送付日</div>
          <div class="table-cell px-2 py-1" :class="rp.sentDate=='20'?'':'text-red-700 font-bold'">{{ rp.sentDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell px-2 py-1 font-bold text-gray-500">締め日</div>
          <div class="table-cell px-2 py-1" :class="rp.closingDate=='月末'?'':'text-red-700 font-bold'">{{ rp.closingDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell px-2 py-1 font-bold text-gray-500">請求送付日</div>
          <div class="table-cell px-2 py-1" :class="rp.billingDate=='月末'?'':'text-red-700 font-bold'">{{ rp.billingDate }}</div>
        </div>
      </div>
    </div>

    <!-- 契約詳細を変更（対象物件のどれかに契約詳細情報があり、サブタスクに「契約詳細登録申請」があれば1つ） -->
    <div v-if="detailSites.length && hasContractSubTask" class="sm:col-span-full flex items-center justify-between gap-3 border-2 border-yellow-500 rounded-md px-3 py-2 bg-yellow-50 mt-2">
      <div>
        <div class="text-sm font-bold text-yellow-800">契約詳細情報のある物件があります<span class="pl-2">{{ detailSites.length }}件</span></div>
        <div class="text-xs text-yellow-800 mt-1">{{ detailSiteNames }}</div>
        <div v-if="rp.classification=='2'" class="text-xs text-red-700 font-bold mt-1">解約する契約は、契約詳細に解約日を入れる申請も必要です。</div>
        <div v-else class="text-xs text-red-700 font-bold mt-1">AKBS稼働管理・清掃員のシフトに影響するため、契約詳細変更も申請してください。</div>
        <div v-if="rp.classification!='2'" class="text-xs text-red-700 font-bold">（勤務、契約終了、得意先・物件コードを変更する場合）</div>
        <div v-if="rp.classification!='2'" class="text-xs text-gray-700 font-bold mt-1">※受注金額のみ変更の場合は不要です。</div>
      </div>
      <!-- 遷移ボタン（メインタスクを一度保存しないと進めない。雇い入れと同じ） -->
      <div class="text-right">
        <div v-if="!rp._id" class="text-xs font-bold text-red-700 mb-1">一度保存しなければ遷移できません</div>
        <div v-else class="text-xs text-gray-600 mb-1">申請の状況：<span class="font-bold" :class="rp.contractDetailStatus ? 'text-indigo-700' : 'text-gray-700'">{{ rp.contractDetailStatus || '未申請' }}</span></div>
        <PrimaryButton text="契約詳細を変更" size="sm" class="whitespace-nowrap" :disabled="!rp._id" @click="toContractDetail()"></PrimaryButton>
      </div>
    </div>

    <!-- 対象物件（全物件まとめての操作） -->
    <div v-if="rp.clientCode" class="sm:col-span-full mt-2">
      <div class="flex items-center">
        <div class="font-bold text-sm text-gray-700">対象物件<span v-if="selectedSites.length" class="pl-3">{{ selectedSites.length }}件</span></div>
        <NumericTextInput2
          name="year"
          v-model="rp.year"
          :format="false"
          :disabled="referenceMode2"
          class="w-24 ml-5"
        />
        <div class="self-center text-xs font-bold text-gray-700 ml-1">年度のビルメンツデータ</div>
      </div>

      <!-- 全物件の全選択・全解除 -->
      <div v-if="!referenceMode && selectedSites.length" class="flex items-center text-xs my-4">
        <span class="text-gray-700 font-bold mr-3">対象物件を</span>
        <span class="text-blue-700 cursor-pointer font-bold mr-4" @click="allCheck(true)">全選択</span>
        <span class="text-blue-700 cursor-pointer font-bold" @click="allCheck(false)">全解除</span>
      </div>

      <!-- 全物件の全契約を解約 -->
      <div v-if="rp.classification=='2'" class="mt-2">
        <input type="checkbox" id="allend" v-model="rp.allEnd" :disabled="referenceMode2" @change="allEndCheck">
        <label for="allend" class="p-2" :class="rp.allEnd?'text-indigo-700 font-bold':'text-gray-700'">全物件の全契約を解約</label>
      </div>
    </div>

    <!-- 物件タブ -->
    <div v-if="rp.clientCode" class="sm:col-span-full">
      <div class="flex items-end flex-wrap gap-1 pl-1">
        <!-- タブは全部同じ幅。物件名が長いときは「…」で切って、マウスを乗せると全名を出す -->
        <div
          v-for="(site, i) in rp.sites"
          :key="'tab'+i"
          class="flex items-center gap-1 px-2 py-2 text-xs font-bold border-2 border-b-0 rounded-t cursor-pointer"
          style="width: 190px;"
          :class="tab==i ? 'bg-blue-700 text-white border-blue-700' : 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'"
          @click="tab = i"
        >
          <div class="flex-1 min-w-0">
            <div class="truncate" :title="tabName(site)">{{ tabName(site) }}</div>
            <div v-if="isEndedSite(site)" :class="tab==i ? 'text-yellow-200' : 'text-red-700'" style="font-size: 10px;">解約済み</div>
          </div>
          <span v-if="checkCount(site)" class="px-1.5 rounded-full bg-yellow-200 text-yellow-800" style="font-size: 10px;">{{ checkCount(site) }}</span>
          <span v-if="!referenceMode2" class="font-normal px-1" :class="tab==i ? 'text-blue-200 hover:text-white' : 'text-gray-400 hover:text-red-700'" @click.stop="removeSite(i)">×</span>
        </div>
        <div
          v-if="!referenceMode2"
          class="px-2 py-2 text-xs font-bold text-center border-2 border-b-0 rounded-t cursor-pointer bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100"
          style="width: 190px;"
          @click="siteModal = true"
        >
          ＋ 物件を追加
        </div>
      </div>

      <!-- 物件追加モーダル（得意先の物件から複数選ぶ。既に選んでいる物件は出さない） -->
      <OrderChangeSiteModal
        v-model="siteModal"
        :open="siteModal"
        :list="addableSites"
        :clientName="rp.clientName"
        @modalSiteSelected="sitesAdded"
      />

      <!-- 物件が無いとき -->
      <div v-if="!rp.sites.length" class="border-2 border-gray-300 rounded-b rounded-tr p-4 text-xs text-gray-600">
        「＋ 物件を追加」から、対象の物件を選んでください。
      </div>

      <div v-if="rp.sites[tab]" class="border-2 border-blue-700 rounded-b rounded-tr p-2">
        <!-- 物件名・物件コード -->
        <div class="text-sm font-bold text-gray-700">
          {{ tabName(rp.sites[tab]) }}
          <span class="text-blue-700 pl-3">物件コード：{{ rp.sites[tab].siteCode }}</span>
          <span v-if="isEndedSite(rp.sites[tab])" class="text-red-700 pl-3">解約済み</span>
        </div>

        <!-- 契約中ビルメンツデータ -->
        <div v-if="rp.sites[tab].siteCode" class="mt-4">
          <div class="flex justify-between border-b border-gray-400 w-full">
            <div class="font-bold text-sm w-fit mt-auto text-gray-700">契約中 ビルメンツデータ<span v-if="rp.sites[tab].contractList" class="pl-3">{{ rp.sites[tab].contractList.length }}件</span></div>
            <div class="flex items-center mb-1 text-xs">
              <PrimaryButton v-if="!referenceMode2" text="再取得" size="xs" class="bg-green-500 ml-5" @click="siteSelected(rp.sites[tab], { siteCode: rp.sites[tab].siteCode })"></PrimaryButton>
            </div>
          </div>
        </div>

        <!-- ローディング -->
        <div v-if="loading" class="text-gray-700 font-bold animate-pulse mt-2">
          契約情報取得中...
        </div>

        <!-- 契約リスト -->
        <div v-if="rp.sites[tab].contractList&&rp.sites[tab].contractList.length" class="mt-2">
          <div v-if="rp.changeClient" class="text-sm font-bold text-indigo-700 mb-2">※得意先変更のため、全ての契約が対象です</div>
          <div v-else class="text-sm font-bold text-gray-700 mb-2">※{{ className(rp.classification) }}する契約にチェックを入れてください</div>
          <div>
            <table class="w-full border border-gray-300 text-xs ">
              <thead class="bg-colu">
                <tr class="text-gray-600">
                  <th scope="col" class="text-center">
                    <!-- この物件の全選択・全解除（全部✓なら✓、一部なら横棒。押すと全部✓のときだけ全解除、それ以外は全選択） -->
                    <input
                      type="checkbox"
                      class="h-4 w-4 rounded p-2"
                      :class="referenceMode2 ? '' : 'cursor-pointer'"
                      :disabled="referenceMode2"
                      :checked="allChecked(rp.sites[tab])"
                      :indeterminate.prop="!allChecked(rp.sites[tab]) && checkCount(rp.sites[tab]) > 0"
                      :title="allChecked(rp.sites[tab]) ? 'この物件の契約を全解除' : 'この物件の契約を全選択'"
                      @click="clickAllCheckbox(rp.sites[tab], $event)"
                    />
                  </th>
                  <th scope="col" class="text-left px-2">作業内容区分<br>作業内容<br>（発注先）</th>
                  <th scope="col" class="">3月</th>
                  <th scope="col" class="">4月</th>
                  <th scope="col" class="">5月</th>
                  <th scope="col" class="">6月</th>
                  <th scope="col" class="">7月</th>
                  <th scope="col" class="">8月</th>
                  <th scope="col" class="">9月</th>
                  <th scope="col" class="">10月</th>
                  <th scope="col" class="">11月</th>
                  <th scope="col" class="">12月</th>
                  <th scope="col" class="">1月</th>
                  <th scope="col" class="">2月</th>
                  <th scope="col" class="px-2">総額</th>
                  <th scope="col" class="px-2">契約日<br>解約日</th>
                </tr>
              </thead>
              <tbody v-for="(row, i) in rp.sites[tab].contractList" :key="i" :class="setColor(row, i)" class="cursor-pointer">
                <tr @click="changeCheck(row)">
                  <td scope="row" rowspan="2" class="text-center">
                    <!-- ボックスのクリックは行に伝えず（stop）、行のクリックと同じ処理を呼ぶ -->
                    <input
                      type="checkbox"
                      class="h-4 w-4 rounded p-2"
                      :class="referenceMode2 ? '' : 'cursor-pointer'"
                      :disabled="referenceMode2"
                      :checked="row.check"
                      @click.stop="clickCheckbox(row, $event)"
                    />
                  </td>
                  <td class="p-2">
                    <div class="font-bold">{{ row.nameKubunWorkContent }}</div>
                    <div class="my-1 text-yellow-800 font-bold">{{ row.nameWorkContent }}</div>
                    <div>（{{ row.purchase }}）</div>
                  </td>
                  <td class="text-center ">{{ row.work3 }}</td>
                  <td class="text-center ">{{ row.work4 }}</td>
                  <td class="text-center ">{{ row.work5 }}</td>
                  <td class="text-center ">{{ row.work6 }}</td>
                  <td class="text-center ">{{ row.work7 }}</td>
                  <td class="text-center ">{{ row.work8 }}</td>
                  <td class="text-center ">{{ row.work9 }}</td>
                  <td class="text-center ">{{ row.work10 }}</td>
                  <td class="text-center ">{{ row.work11 }}</td>
                  <td class="text-center ">{{ row.work12 }}</td>
                  <td class="text-center ">{{ row.work1 }}</td>
                  <td class="text-center ">{{ row.work2 }}</td>
                  <td class="text-center px-2">{{ row.totalFee }}</td>
                  <td class="text-center px-2">
                    <div>{{ row.dateAgreement }}</div>
                    <div class="mt-1" :class="row.dateCancellation?'text-red-700 font-bold':''">{{ row.dateCancellation || '-' }}</div>
                  </td>
                </tr>
                <tr>
                  <td colspan="15">
                    <div class="mr-1">
                      <textarea
                        placeholder="備考"
                        v-model="row.memo"
                        :rows="2"
                        :disabled="referenceMode"
                        class="border-gray-400 text-sm text-gray-700 rounded w-full"
                        style="field-sizing: content;"
                      ></textarea>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 契約詳細情報（件数と担当清掃員だけ。変更は契約詳細入力画面で行う） -->
        <div v-if="rp.sites[tab].siteCode" class="mt-5 border-b border-gray-400">
          <div class="font-bold text-sm w-fit mt-auto text-gray-700">契約中 契約詳細情報データ<span class="pl-3">{{ rp.sites[tab].detailList.length }}件</span></div>
        </div>
        <div v-if="rp.sites[tab].detailList.length" class="text-xs text-gray-700 mt-1">
          <div class="flex flex-wrap gap-x-4">
            <div v-for="(d, i) in rp.sites[tab].detailList" :key="'det'+i">● 契約コード（{{ d.cdContract }}） {{ d.contentsWorkName }}</div>
          </div>
        </div>
        <div v-if="rp.sites[tab].staffList.length" class="text-xs text-gray-700 mt-2">
          <div class="font-bold">担当清掃員</div>
          <div class="border border-gray-300 rounded bg-blue-50">
            <div v-for="(staff, i) in rp.sites[tab].staffList" :key="'staff'+i" class="flex p-2">
              <div>● 契約コード（{{ staff.cdContract }}）</div>
              <div class="ml-2 font-bold">{{ staff.nameStaff }}</div>
              <div class="ml-2">（{{ staff.staffDailyCleaning }}）</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 物件ごとの状況（タブを切り替えなくても分かる） -->
    <div v-if="selectedSites.length > 1" class="sm:col-span-full border border-gray-300 rounded text-xs text-gray-700 overflow-hidden">
      <div class="bg-colu px-2 py-1 font-bold">物件ごとの状況</div>
      <div v-for="(site, i) in selectedSites" :key="'st'+i" class="flex px-2 py-1 border-b border-gray-200">
        <div class="font-bold" style="width: 180px;">{{ tabName(site) }}<span v-if="isEndedSite(site)" class="text-red-700 pl-2">解約済み</span></div>
        <div style="width: 120px;" :class="checkCount(site) ? '' : 'text-red-700 font-bold'">チェック {{ checkCount(site) }} / {{ site.contractList.length }}件</div>
        <div :class="site.detailList.length ? '' : 'text-gray-500'">契約詳細情報 {{ site.detailList.length ? site.detailList.length + '件' : 'なし' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import * as backend from '@libs/backend'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import InputGroupLabel from './InputGroupLabel.vue'
  import OrderChangeSiteModal from './OrderChangeSiteModal.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import * as moment from 'moment'
  import * as utils from '@libs/utils'
  import * as dialogs from '@libs/dialogs'
  import * as taskRequestManager from '@managers/taskRequestManager'
  // サブタスク「契約詳細登録申請」があるときだけ、契約詳細入力画面へのボタン（黄色い帯）を出す（受注処理 OrderNewComponents と同じ）
  import { AKBS_SUB_TASK, isAkbsSubTask } from '@libs/constantsAKBS'

  const items = {
    classification: '種別',
    clientName: '得意先',
    changeDate: '変更日（適用開始日）',
  }

  // 必須項目
  const require = [
    'classification',
    'changeDate',
    'clientName'
  ]

  // この画面で使う rp のキーと初期値（他のカテゴリーでは不要なので、初期値の雛形には入れず、この画面を開いたときに揃える）
  const rpDefaults = {
    // 物件ごとの情報
    sites: [],
    // ビルメンツデータの年度
    year: '',
    // 全物件の全契約を解約
    allEnd: false,
    // 得意先変更
    changeClient: false,
    clientName2: '',
    clientCode2: '',
    // 請求先情報（akbsTable/getBillingData）
    sentDate: '',
    closingDate: '',
    billingDate: '',
    cc: '',
    cn1: '',
    cn2: ''
  }

  /**
   * 物件1件分の入れ物（キーを最初から持たせる）
   */
  function createSite() {
    return {
      siteCode: '',
      site1: '',
      site2: '',
      buildingName: '',
      // 契約状況（物件リストの「（契約中）」「（解約）」）
      agreementFlg: '',
      // 契約台帳（ビルメンツデータ）
      contractList: [],
      // 契約詳細情報（件数表示用。変更は契約詳細入力画面で行う）
      detailList: [],
      // 担当清掃員
      staffList: []
    }
  }

  export default {
    components: {
      PrimaryButton,
      WmsDateInput,
      InputGroupLabel,
      NumericTextInput2,
      OrderChangeSiteModal,
      SelectionButton2,
      WmsSuggestInput,
    },

    props: {
      rp: {
        type: Object,
        default: () => {}
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      // 参照モードもしくはAKBS登録済み
      referenceMode2: {
        type: Boolean,
        default: false
      },
      // 得意先リスト
      clientLists: {
        type: Array,
      },
    },

    data() {
      return {
        loading: false,
        // このメインタスクのサブタスクに「契約詳細登録申請」があるか（あれば黄色い帯を出す）
        hasContractSubTask: false,
        // プロパティと項目名
        items: items,
        // 種別リスト
        classList: [{ value: '1', text: '変更' }, { value: '2', text: '解約' }],
        // 表示中の物件タブ
        tab: 0,
        // 物件追加モーダル
        siteModal: false,
        // 選んだ得意先の物件リスト（得意先を選んだときに取得）
        siteList: []
      }
    },

    computed: {
      /**
       * 種別名
       */
      className() {
        return (e) => {
          if (e && e.length) {
            const res = this.classList.find((c) => {
              return c.value == e[0]
            })
            if (res && res.text) {
              return res.text
            }
          }
          return ''
        }
      },

      /**
       * 物件コードが決まっている物件
       */
      selectedSites() {
        return (this.rp.sites || []).filter((s) => s.siteCode)
      },

      /**
       * 契約詳細を変更する必要がありそうな物件
       * ビルメンツデータの作業内容区分コードが1000・2000（日常清掃・管理員）の契約にチェックがあり、かつ契約詳細情報がある物件
       */
      detailSites() {
        return this.selectedSites.filter((s) => {
          if (!s.detailList || !s.detailList.length) {
            return false
          }
          return (s.contractList || []).some((c) => c.check && ['1000', '2000'].includes(c.cdKubunWorkContent))
        })
      },

      /**
       * 契約詳細情報のある物件名（「、」区切り）
       */
      detailSiteNames() {
        return this.detailSites.map((s) => this.tabName(s)).join('、')
      },

      /**
       * 物件名の候補（選んだ得意先の物件だけ）
       */
      siteCandidates() {
        if (!this.rp.clientCode) {
          return []
        }
        return this.siteList
      },

      /**
       * モーダルで追加できる物件（得意先の物件から、既に選んでいる物件を除く）
       */
      addableSites() {
        return this.siteCandidates.filter((b) => !this.selectedSites.some((s) => s.siteCode == b.siteCode))
      },

      /**
       * 得意先の契約中の物件を全部選んでいるか（件名を「得意先名 全物件〇〇」にする判定）
       */
      isAllSites() {
        if (!this.rp.clientCode || !this.selectedSites.length) {
          return false
        }
        const all = this.siteCandidates.filter((b) => b.agreementFlg && b.agreementFlg.indexOf('契約中') > -1)
        if (!all.length) {
          return false
        }
        return all.every((b) => this.selectedSites.some((s) => s.siteCode == b.siteCode))
      },

      /**
       * タブに出す物件名
       */
      tabName() {
        return (site) => {
          if (site.site1 || site.site2) {
            return (site.site1 || '') + (site.site2 ? ' ' + site.site2 : '')
          }
          return site.buildingName || ''
        }
      },

      /**
       * 解約済みの物件か
       */
      isEndedSite() {
        return (site) => {
          return !!(site.agreementFlg && site.agreementFlg.indexOf('解約') > -1)
        }
      },

      /**
       * 物件の契約でチェックの入っている件数
       */
      checkCount() {
        return (site) => {
          return (site.contractList || []).filter((c) => c.check).length
        }
      },

      /**
       * 物件の契約が全部チェックされているか（契約が無ければ false）
       */
      allChecked() {
        return (site) => {
          const list = site.contractList || []
          return list.length > 0 && list.every((c) => c.check)
        }
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item) => {
          let name = items[item]
          if (item == 'changeDate') {
            if (this.className(this.rp.classification) == '解約') {
              name = '解約日'
            }
          }
          if (this.isRequired(item)) {
            if (!this.rp[item]) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を入力してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item)=> {
          const name = items[item]
          if (this.isRequired(item)) {
            if (!this.rp[item] || !this.rp[item].length) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を選択してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須判定
       */
      isRequired() {
        return (item) => {
          if (require.includes(item)) {
            return true
          }
          return false
        }
      }
    },

    async created() {
      if (this.rp) {
        // この画面で使うキーが無ければ揃える（新規・古い依頼どちらも）
        const keys = Object.keys(rpDefaults)
        for (let i = 0; i < keys.length; i++) {
          if (this.rp[keys[i]] === undefined) {
            this.$set(this.rp, keys[i], utils.clone(rpDefaults[keys[i]]))
          }
        }

        // 年度をセット
        if (!this.rp.year) {
          this.rp.year = moment().add(-2, 'months').format('YYYY')
        }

        // 得意先が決まっていれば、その得意先の物件リストを取る（閲覧のみなら不要）
        if (this.rp.clientCode && !this.referenceMode2) {
          this.getSiteList()
        }

        // 途中で足したキーが無い物件があれば揃える
        for (let i = 0; i < this.rp.sites.length; i++) {
          const site = this.rp.sites[i]
          const keys = Object.keys(createSite())
          for (let j = 0; j < keys.length; j++) {
            if (site[keys[j]] === undefined) {
              this.$set(site, keys[j], createSite()[keys[j]])
            }
          }
        }

        // 黄色い帯を出すか（サブタスクに「契約詳細登録申請」があるか）
        await this.loadContractSubTask()
      }
    },

    methods: {
      /**
       * このメインタスクのサブタスクに「契約詳細登録申請」があるかを取る（あれば、契約詳細入力画面へのボタンを出す）
       * 契約詳細を変更するかどうかを最終的に決めるのはユーザーで、そのサブタスクを立てたときだけ入口を出す
       * サブタスクはメインタスクを保存したあとで依頼するものなので、未保存（_id 無し）なら無いまま
       */
      async loadContractSubTask() {
        this.hasContractSubTask = false
        if (!this.rp || !this.rp._id) {
          return
        }
        const subTasks = await taskRequestManager.getByRequestPostId(this, this.rp._id)
        this.hasContractSubTask = (subTasks || []).some(s => isAkbsSubTask(s.requestTask, AKBS_SUB_TASK.CONTRACT))
      },

      /**
       * 種別変更
       */
      async changeClassification() {
        this.rp.allEnd = false
        // 物件コードが決まっている物件は取り直す
        for (let i = 0; i < this.rp.sites.length; i++) {
          const site = this.rp.sites[i]
          if (site.siteCode) {
            await this.siteSelected(site, { siteCode: site.siteCode })
          }
        }
        this.setTitle()
      },

      /**
       * モーダルで選んだ物件を追加（タブを足して、最初に足したタブへ移る）
       * @param list 選んだ物件
       */
      async sitesAdded(list) {
        this.siteModal = false
        if (!list || !list.length) {
          return
        }
        const first = this.rp.sites.length
        for (let i = 0; i < list.length; i++) {
          // 既に入っている物件は足さない
          if (this.rp.sites.some((s) => s.siteCode == list[i].siteCode)) {
            continue
          }
          const site = createSite()
          this.rp.sites.push(site)
          await this.siteSelected(site, list[i])
        }
        this.tab = Math.min(first, this.rp.sites.length - 1)
      },

      /**
       * 物件を外す
       * @param i 物件の位置
       */
      async removeSite(i) {
        const site = this.rp.sites[i]
        if (site.siteCode) {
          const log = await dialogs.showConfirmDialog('物件を外します', this.tabName(site) + ' を対象から外しますか？')
          if (log != 'YES') {
            return
          }
        }
        this.rp.sites.splice(i, 1)
        if (this.tab >= this.rp.sites.length) {
          this.tab = Math.max(this.rp.sites.length - 1, 0)
        }
        this.setTitle()
      },

      /**
       * 物件選択
       * @param site 対象の物件
       * @param e 選択した物件（再取得のときは siteCode だけ）
       */
      async siteSelected(site, e) {
        // 同じ物件を2回選んでいないか
        if (e.siteCode) {
          const same = this.rp.sites.find((s) => s !== site && s.siteCode == e.siteCode)
          if (same) {
            await dialogs.showErrorDialog('同じ物件が選ばれています', this.tabName(same) + ' は既に対象に入っています。')
            site.buildingName = ''
            site.siteCode = ''
            site.site1 = ''
            site.site2 = ''
            return
          }
        }

        site.contractList = []
        site.detailList = []
        site.staffList = []
        site.siteCode = e.siteCode
        site.site1 = ''
        site.site2 = ''
        // 再取得（siteCode だけ）のときは契約状況を残す
        if (e.agreementFlg !== undefined) {
          site.agreementFlg = e.agreementFlg || ''
        }

        // 契約台帳そのままの表示を別に保存
        if (e.site1) {
          site.site1 = e.site1
          site.site2 = e.site2
          site.buildingName = (e.site1 || '')
          if (e.site2) {
            site.buildingName = (e.site1 || '') + ' ' + e.site2
          }
        }

        if (e.siteCode) {
          this.loading = true
          try {
            // API: akbsTable/getContractNew
            // day：契約詳細情報は契約コードごとに複数行（履歴）あるので、変更日（解約日）に効いている行を1行ずつ返してもらう（無ければ今日）
            const res = await backend.searchData('akbsTable/getContractNew', { siteCode: e.siteCode, year: this.rp.year, day: this.rp.changeDate || '' })
            const data = (res.data && res.data.data) ? res.data.data : {}

            // ビルメンツデータ
            if (data.contract && data.contract.length) {
              if (!e.site1) {
                // 契約台帳そのままの表示を別に保存
                const con = data.contract[0]
                site.site1 = con.nameSite1
                site.site2 = con.nameSite2
                site.buildingName = (con.nameSite1 || '')
                if (con.nameSite2) {
                  site.buildingName = (con.nameSite1 || '') + ' ' + con.nameSite2
                }
              }
              // チェックと備考のキーを最初から持たせる（全物件の全契約を解約、または得意先変更がONなら最初からチェック）
              site.contractList = data.contract.map((c) => {
                return { ...c, check: !!(this.rp.allEnd || this.rp.changeClient), memo: '' }
              })
            }
            // 契約詳細情報（件数表示用）
            if (data.detail && data.detail.length) {
              site.detailList = data.detail
            }
            // 担当清掃員
            if (data.staff && data.staff.length) {
              site.staffList = data.staff
            }
          } catch (err) {
            console.log(err)
            await dialogs.showErrorDialog('取得エラー', this.tabName(site) + ' の契約情報の取得に失敗しました。「再取得」を押してください。')
          } finally {
            this.loading = false
          }
        }

        this.setTitle()
      },

      /**
       * 得意先選択
       * @param e 選択した得意先
       */
      async clientSelected(e) {
        // 同じ得意先を選び直しただけなら、物件はそのまま
        if (this.rp.clientCode && this.rp.clientCode == e.clientCode) {
          this.rp.clientName = e.clientName + ' ' + e.clientDepartmentName
          return
        }
        // 得意先を変えたら、選んでいた物件は外す
        if (this.rp.clientCode && this.selectedSites.length) {
          const log = await dialogs.showConfirmDialog('得意先を変えます', '選んでいる物件（' + this.selectedSites.length + '件）は対象から外れます。よろしいでしょうか？')
          if (log != 'YES') {
            const cl = (this.clientLists || []).find((c) => c.clientCode == this.rp.clientCode)
            if (cl) {
              this.rp.clientName = cl.clientName + ' ' + cl.clientDepartmentName
            }
            return
          }
        }
        this.rp.clientName = e.clientName + ' ' + e.clientDepartmentName
        this.rp.clientCode = e.clientCode
        this.rp.clientAddress1 = e.address1
        this.rp.clientAddress2 = e.address2
        this.rp.sites = []
        this.tab = 0
        this.rp.allEnd = false
        await this.getBillingData()
        await this.getSiteList()

        // 得意先の物件が1件しかなければ、選んだことにする
        if (this.siteCandidates.length == 1) {
          await this.sitesAdded([this.siteCandidates[0]])
        }
        this.setTitle()
      },

      /**
       * 得意先の欄を消したら、得意先と物件を全部外す
       */
      clientChange() {
        if (!this.rp.clientName) {
          this.clearClient()
        }
      },

      /**
       * 得意先と物件を全部外す
       */
      clearClient() {
        this.rp.clientCode = ''
        this.rp.clientName = ''
        this.rp.clientAddress1 = ''
        this.rp.clientAddress2 = ''
        this.rp.changeClient = false
        this.rp.clientName2 = ''
        this.rp.clientCode2 = ''
        this.rp.cc = ''
        this.rp.cn1 = ''
        this.rp.cn2 = ''
        this.rp.sentDate = ''
        this.rp.closingDate = ''
        this.rp.billingDate = ''
        this.rp.allEnd = false
        this.rp.sites = []
        this.siteList = []
        this.tab = 0
        this.setTitle()
      },

      /**
       * 選んだ得意先の物件リストを取得
       */
      async getSiteList() {
        this.siteList = []
        if (!this.rp.clientCode) {
          return
        }
        try {
          // API: akbsTable/getSiteListForEstimate
          const res = await backend.searchData('akbsTable/getSiteListForEstimate', { clientCode: this.rp.clientCode })
          if (res.data && res.data.data && res.data.data.length) {
            this.siteList = res.data.data
          }
        } catch (err) {
          console.log(err)
          await dialogs.showErrorDialog('取得エラー', '得意先の物件リストの取得に失敗しました。得意先を選び直してください。')
        }
      },

      /**
       * 得意先選択（変更後。変更前と同じ得意先は選べない）
       */
      async clientSelected2(e) {
        if (e.clientCode == this.rp.clientCode) {
          this.rp.clientName2 = ''
          this.rp.clientCode2 = ''
          await dialogs.showErrorDialog('変更前と同じ得意先です', '変更後の得意先に、変更前と同じ得意先が選ばれています。別の得意先を選択してください。')
          return
        }
        this.rp.clientName2 = e.clientName + ' ' + e.clientDepartmentName
        this.rp.clientCode2 = e.clientCode
      },

      /**
       * 得意先変更（変更後）
       */
      clientNameChanged2() {
        if (!this.rp.clientName2) {
          this.rp.clientCode2 = null
        }
      },

      /**
       * 得意先変更チェックＢＯＸ
       */
      async changeCheckCode() {
        await this.$nextTick()
        if (!this.rp.changeClient) {
          this.rp.clientName2 = ''
          this.rp.clientCode2 = ''
        } else {
          // 得意先が変わると物件の契約は全部移るので、対象物件の契約を全部チェックにする
          this.allCheck(true)
        }
      },

      /**
       * 得意先変更をOFFにするか聞く（契約のチェックを外そうとしたとき）
       * @returns OFFにした（続けてよい）なら true
       */
      confirmOffChangeClient() {
        const log = window.confirm('得意先変更のため、全ての契約が対象になっています。\r\n「得意先 変更」をOFFにしますか？')
        if (log) {
          this.rp.changeClient = false
          this.rp.clientName2 = ''
          this.rp.clientCode2 = ''
        }
        return log
      },

      /**
       * 全選択OR解除
       * @param val true：選択、false：解除
       * @param site 対象の物件（無ければ全物件）
       */
      allCheck(val, site) {
        // 得意先変更中に外そうとしたら、得意先変更をOFFにするか聞く
        if (!val && this.rp.changeClient && !this.confirmOffChangeClient()) {
          return
        }
        const sites = site ? [site] : this.selectedSites
        sites.forEach((s) => {
          s.contractList.forEach((c) => {
            c.check = val
          })
        })
        // 全物件の全契約を解約がONで外したら、OFFにする
        if (!val && this.rp.allEnd) {
          this.rp.allEnd = false
        }
      },

      /**
       * チェック
       */
      changeCheck(row) {
        if (this.referenceMode2) {
          return
        }
        // 得意先変更中に外そうとした場合
        if (this.rp.changeClient && row.check && !this.confirmOffChangeClient()) {
          return
        }
        // 解約で全契約解除の場合
        if (this.rp.classification=='2' && this.rp.allEnd && row.check) {
          const log = window.confirm('「全物件の全契約を解約」をOFFにしますか？')
          if (log) {
            this.rp.allEnd = false
          } else {
            return
          }
        }
        row.check = !row.check
      },

      /**
       * チェックボックスのクリック（行のクリックと同じ処理。確認で取りやめたときは表示を値に戻す）
       * @param row 対象契約データ
       * @param e クリックイベント
       */
      clickCheckbox(row, e) {
        this.changeCheck(row)
        e.target.checked = row.check
      },

      /**
       * 見出しのチェックボックスのクリック（この物件の全選択・全解除）
       * 全部チェック済みなら全解除、それ以外（一部・無し）は全選択。確認で取りやめたときは表示を値に戻す
       * @param site 対象の物件
       * @param e クリックイベント
       */
      clickAllCheckbox(site, e) {
        this.allCheck(!this.allChecked(site), site)
        e.target.checked = this.allChecked(site)
        e.target.indeterminate = !this.allChecked(site) && this.checkCount(site) > 0
      },

      /**
       * 背景色設定
       * @param row 対象契約データ
       * @param i 行の位置
       */
      setColor(row, i) {
        if (row.check) {
          return 'bg-yellow-200 border-b-2 border-white'
        }
        if (i % 2 != 0) {
          return 'bg-blue'
        } else {
          return ''
        }
      },

      /**
       * 全物件の全契約を解約
       */
      async allEndCheck() {
        await this.$nextTick()
        if (this.rp.allEnd) {
          this.allCheck(true)
        }
      },

      /**
       * タイトル設定
       * 件名は全物件名を並べる。得意先の契約中の物件を全部選んだら「得意先名 全物件〇〇」
       */
      setTitle() {
        let day = ''
        if (this.rp.changeDate) {
          day = moment(this.rp.changeDate + ' 00:00:00').format('YYYY年M月D日')
        }
        const kind = this.className(this.rp.classification)
        const siteNames = this.selectedSites.map((s) => this.tabName(s)).join('、')
        let names = siteNames
        if (this.isAllSites) {
          names = (this.rp.clientName || '').trim() + ' 全物件' + kind
        } else if (this.selectedSites.length > 5) {
          // 物件名は5件まで。それ以上は「他○件」
          names = this.selectedSites.slice(0, 5).map((s) => this.tabName(s)).join('、') + ' 他' + (this.selectedSites.length - 5) + '件'
        }
        this.rp.inquiry_title = `【${day + ' ' + kind}】 ${names}`
        // 一覧・検索用に、旧画面と同じキーにも物件名（全物件）と先頭の物件コードを入れておく
        this.rp.buildingName = siteNames
        this.rp.siteCode = this.selectedSites.length ? this.selectedSites[0].siteCode : ''
      },

      /**
       * 契約詳細入力画面へ（メインタスクを一度保存していないと進めない）
       */
      toContractDetail() {
        if (!this.rp._id) {
          return
        }
        const route = {
          name: 'AkbsContractForm',
          query: { requestPostId: this.rp._id }
        }
        // 親が遷移の仕方を決めたいとき（サブタスク画面：別タブで開く）は親に任せる
        if (this.$listeners.toContractDetail) {
          this.$emit('toContractDetail', route)
          return
        }
        this.$router.push(route)
      },

      /**
       * バリデーション
       */
      async validation() {
        // 入力必須確認
        for (let i = 0; i < require.length; i++) {
          let res
          const row = require[i]
          if (row == 'classification') {
            res = this.requireValidateArr(row)
          } else {
            res = this.requireValidateStr(row)
          }
          if (!res.result) {
            await dialogs.showErrorDialog('入力確認', res.message)
            return false
          }
        }

        // 得意先名だけ入っていて得意先コードが取れていない
        if (!this.rp.clientCode) {
          await dialogs.showErrorDialog(this.rp.clientName + 'の得意先コード 取得失敗', '得意先コードが取得できませんでした。再度、得意先をドロップダウンから選択してください。')
          return false
        }

        // 物件が1件も無い
        if (!this.selectedSites.length) {
          await dialogs.showErrorDialog('入力確認', '物件が選ばれていません。「＋ 物件を追加」から物件を選んでください。')
          return false
        }

        // 得意先変更ありの場合
        if (this.rp.classification[0] == '1') {
          if (this.rp.changeClient && (!this.rp.clientName2 || !this.rp.clientCode2)) {
            await dialogs.showErrorDialog('変更後の得意先 未選択', '得意先変更ですが、変更後の得意先が選ばれていません。ドロップダウンから選択してください。')
            return false
          }
          if (this.rp.changeClient && this.rp.clientCode2 == this.rp.clientCode) {
            await dialogs.showErrorDialog('変更前と同じ得意先です', '変更後の得意先が変更前と同じです。別の得意先を選択してください。')
            return false
          }
        }

        // ビルメンツデータがあるのにチェックがない物件
        for (let i = 0; i < this.rp.sites.length; i++) {
          const site = this.rp.sites[i]
          if (site.contractList && site.contractList.length && !this.checkCount(site)) {
            this.tab = i
            const log = await dialogs.showConfirmDialog('ビルメンツの契約に1件もチェックなし', this.tabName(site) + ' のビルメンツのデータに1件も' + this.className(this.rp.classification) + 'のチェックがついていませんが、よろしいでしょうか？')
            if (log != 'YES') {
              return false
            }
          }
        }
        return true
      },

      /**
       * 請求先マスタから情報取得（得意先コードで引く）
       */
      async getBillingData() {
        if (!this.rp.clientCode) {
          await dialogs.showErrorDialog('得意先コードなし', '得意先をドロップダウンから選択してください。')
          return
        }
        try {
          // API: akbsTable/getBillingData
          const res = await backend.searchData('akbsTable/getBillingData', { clientCode: this.rp.clientCode })
          if (res.data.data) {
            const data = res.data.data
            for (let i = 0; i < Object.keys(data).length; i++) {
              const key = Object.keys(data)[i]
              this.rp[key] = data[key]
            }
          }
        } catch (err) {
          console.log(err)
          await dialogs.showErrorDialog('取得エラー', '請求先情報の取得に失敗しました。「再取得」を押してください。')
        }
      },
    }
  }
</script>

<style scoped>
  table {
    background: white;
  }

  .bg-colu {
    background: #edecf7;
  }

  .bg-blue {
    background: rgb(243 247 249);
  }

  #client-name div input[type=text] {
    font-size: 13px !important;
  }
</style>
